module.exports = __webpack_public_path__ + "img/07.snowy-cloud-light.687d2505.svg";